export default function Loading() {
    return (
        <span className='block m-auto text-center w-[62px] h-[18px]' role='status' aria-live='polite' aria-label='Loading'>
            <span className='inline-block w-[18px] h-[18px] rounded-full animate-in zoom-in-75 duration-700 repeat-infinite fill-mode-both bg-[#ccc]' />
            <span className='inline-block w-[18px] h-[18px] rounded-full animate-in zoom-in-75 duration-700 delay-200 repeat-infinite fill-mode-both bg-[#ccc]' />
            <span className='inline-block w-[18px] h-[18px] rounded-full animate-in zoom-in-75 duration-700 delay-100 repeat-infinite fill-mode-both bg-[#ccc]' />
        </span>
    )
}
